import { useEffect, useState } from "react";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import CustomLoader from "../static/CustomLoader";

const SuggandActred = ({
  selectedId,
  mode,
  onHide,
  setRefresh,
  typeData,
  sugesttiondata,
  actrefData,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [header, setHeader] = useState("");
  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  useEffect(() => {
    if (mode === "U") {
      const fetchsuggandActrefData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${apiUrl}suggandactref/id/${selectedId}`,
            { headers },
          );
          const data = response.data;

          if (data.cd === 1) {
            toast.info(data.description);
          } else {
            setId(data.id);
            setCode(data.code);
            setType(data.type);
            setHeader(data.header || "");
            setName(data.name || "");
            setContent(data.content);
          }
        } catch (error) {
          toast.error("Failed to fetch details.");
        } finally {
          setLoading(false);
        }
      };

      fetchsuggandActrefData();
    }
  }, [mode]);

  function clearFields() {
    setId("");
    setCode("");
    setType("");
  }

  const validateFields = () => {
    let errors = {};
    if (!type) errors.type = "Type is required...";
    if (!header) errors.header = "Type is required...";
    if (!name) errors.name = "Type is required...";
    return errors;
  };

  const handlesubmit = async () => {
    setLoading(true);

    const fieldErrors = validateFields();
    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    }
    const payload = {
      id: id,
      code: code,
      type: type,
      header: header || 0,
      name: name || "",
      content: content || "",
    };
    if (mode === "A") {
      payload.id = 0;
      payload.code = 0;
      try {
        const response = await axios.post(`${apiUrl}suggandactref`, payload, {
          headers,
        });
        if (response.data.cd === 1) {
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
        }
      } catch (error) {
        toast.error("Something went wrong while adding data.");
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await axios.put(
          `${apiUrl}suggandactref/${selectedId}`,
          payload,
          { headers },
        );
        if (response.data.cd === 1) {
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
        }
        setShowSucessModal(true);
      } catch (error) {
        toast.error("Something went wrong while updating data.");
      } finally {
        setLoading(false);
      }
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  /*Handle Update */
  return (
    <>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <div className="popupmodal-maindiv">
        <FormGroup>
          <Label>Type</Label>
          <Select
            options={typeData}
            value={typeData.find((t) => t.value === type) || null}
            onChange={(selected) => {
              setType(selected.value);
              setHeader(selected.value === 3 || selected.value === 4 ? 1 : 1);
              setName("");
              setContent("");
            }}
            placeholder="Select Type"
            styles={customStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
          {errors.type && <div className="text-danger">{errors.type}</div>}
        </FormGroup>

        {type === 1 && (
          <>
            {/* Suggestion Type */}
            <FormGroup>
              <Label>Suggestion Type</Label>
              <Select
                isClearable
                options={sugesttiondata}
                value={sugesttiondata.find((s) => s.value === header) || null}
                onChange={(selected) => setHeader(selected?.value || "")}
                placeholder="Select Suggestion"
                styles={customStyles}
              />
              {errors.header && (
                <div className="text-danger">{errors.header}</div>
              )}
            </FormGroup>
          </>
        )}

        {type === 2 && (
          <>
            {/* Act Reference Type */}
            <FormGroup>
              <Label>Act Reference Type</Label>
              <Select
                isClearable
                options={actrefData}
                value={actrefData.find((a) => a.value === header) || null}
                onChange={(selected) => setHeader(selected?.value || "")}
                placeholder="Select Act Reference"
                styles={customStyles}
              />
              {errors.header && (
                <div className="text-danger">{errors.header}</div>
              )}
            </FormGroup>
          </>
        )}

        <FormGroup>
          <Label>Name</Label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
          />
          {errors.name && <div className="text-danger">{errors.name}</div>}
        </FormGroup>
        <FormGroup>
          <Label>Content</Label>
          <textarea
            className="form-control"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter Content"
            rows={6}
            style={{
              minHeight: "120px",
              resize: "vertical",
              whiteSpace: "pre-wrap",
            }}
          />
        </FormGroup>
        <div className="text-end">
          <button className="btn btn-success" onClick={handlesubmit}>
            Save
          </button>
          <button className="btn btn-danger" onClick={clearFields}>
            Reset
          </button>
        </div>

        {loading && <CustomLoader />}
      </div>
    </>
  );
};

export default SuggandActred;
